import * as React from 'react';
import { SmartTextArea } from '@syncfusion/ej2-inputs';
import { ComponentBase, applyMixins } from '@syncfusion/ej2-react-base';
/**
 * Represents the React Smart TextArea Component
 * ```html
 * <SmartTextArea></SmartTextArea>
 * ```
 */
export class SmartTextAreaComponent extends SmartTextArea {
    constructor(props) {
        super(props);
        this.initRenderCalled = false;
        this.checkInjectedModules = false;
        this.statelessTemplateProps = null;
        this.templateProps = null;
        this.immediateRender = true;
        this.isReactMock = true;
        this.portals = [];
    }
    render() {
        this.isReactMock = false;
        if (((this.element && !this.initRenderCalled) || this.refreshing) && !this.isReactForeceUpdate) {
            super.render();
            this.initRenderCalled = true;
        }
        else {
            return React.createElement(React.Fragment, null, [].concat(React.createElement("textarea", this.getDefaultAttributes()), this.portals));
        }
    }
}
applyMixins(SmartTextAreaComponent, [ComponentBase, React.Component]);
